"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUrl = getUrl;

var _urlHelper = require("./url-helper");

var suffixByType = {
  base: '',
  upload: '/v1.0/images',
  uploadFromUrl: '/v1.0/images/url'
};

function getUrl(type) {
  var suffix = suffixByType[type];

  if (suffix == null) {
    return Error("Unknown type: ".concat(type));
  }

  return (0, _urlHelper.api)(suffix, 'storage');
}